module.exports = __webpack_public_path__ + "img/25.b27c3174.svg";